import {useState} from 'react'
import {useNavigate} from 'react-router-dom'

import useConfrimCookie from './useConfrimCookie'
import useLoginCookie from './useLoginCookie'
import useRoleCookie from './useRoleCookie'
import useNameCookie from './useNameCookie'
import useAlertModalAtom from './useAlertModalAtom'
import useSpinnerAtom from './useSpinnerAtom'

const useFetch = () => {
	const navigate = useNavigate()
	const [data, setData] = useState()

	const [confirmCookie, , deleteConfirmCookie] = useConfrimCookie()
	const [cookie, , deleteCookie] = useLoginCookie()
	const [, , deleteRoleCookie] = useRoleCookie()
	const [, , deleteNameCookie] = useNameCookie()
	const [, setAlert] = useAlertModalAtom()
	const [, openSpinnerEvent, closeSpinnerEvent] = useSpinnerAtom()
	const [isLoading, setIsLoading] = useState(false)

	const request = async (method, path, body, formdata) => {
		const convertResponse = {}

		try {
			setIsLoading(true)
			const object = {
				method: method,
				headers: {},
			}

			// headers 삽입
			if (confirmCookie) object['headers']['confirm'] = confirmCookie
			else if (cookie) object['headers']['token'] = cookie

			// body & formdata 삽입
			if (body) {
				object['headers']['Content-Type'] = 'application/json'
				object['body'] = JSON.stringify(body)
			} else if (formdata) {
				openSpinnerEvent()
				object['body'] = formdata
			}

			// 캐시 방지 헤더 추가
			object['headers']['Cache-Control'] = 'no-cache, no-store, must-revalidate'
			object['headers']['Pragma'] = 'no-cache'
			object['cache'] = 'no-store'

			// 요청 전송
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}${path}`,
				object
			)

			// 응답 내용 저장
			convertResponse.statusCode = response.status
			// convertResponse.data = await response.json()

			const contentType = response.headers.get('content-type')
			const contentLength = response.headers.get('content-length')

			if (contentLength === '0' || response.status === 204) {
				convertResponse.data = null
			} else if (contentType && contentType.includes('application/json')) {
				const text = await response.text()
				if (text.trim()) {
					try {
						convertResponse.data = JSON.parse(text)
					} catch (parseError) {
						convertResponse.data = {message: 'Invalid JSON response'}
					}
				} else {
					convertResponse.data = null
				}
			} else {
				convertResponse.data = await response.text()
			}

			// 공통 status code 후처리
			switch (response.status) {
				case 400:
					if (convertResponse.data?.error_code === 'LIMIT_FILE_SIZE') {
						setAlert('첨부 파일의 용량이 너무 큽니다.')
					}
					break
				case 401:
					if (convertResponse.data?.error_code === 'TOKEN_EXPIRED') {
						setAlert('로그인 토큰이 만료되었습니다.\n다시 로그인해주세요.')
						deleteCookie()
						deleteRoleCookie()
						deleteNameCookie()
						navigate('/')
					} else if (convertResponse.data?.error_code === 'TOKEN_INVALID') {
						setAlert('허용되지 않은 로그인 토큰 입니다.\n다시 로그인해주세요.')
						deleteCookie()
						deleteRoleCookie()
						deleteNameCookie()
						navigate('/')
					} else if (convertResponse.data?.error_code === 'TOKEN_MISSING') {
						setAlert('로그인 토큰을 찾을 수 없습니다.')
						deleteCookie()
						deleteRoleCookie()
						deleteNameCookie()
						navigate('/')
					} else if (convertResponse.data?.error_code === 'CONFIRM_EXPIRED') {
						setAlert('연락처 인증 시간이 만료되었습니다.')
						deleteConfirmCookie()
					} else if (convertResponse.data?.error_code === 'CONFIRM_INVALID') {
						setAlert('허용되지 않은 연락처 인증 토큰 입니다.')
						deleteConfirmCookie()
					} else if (convertResponse.data?.error_code === 'CONFIRM_MISSING') {
						setAlert('연락처 인증이 필요합니다.')
						deleteConfirmCookie()
					}

					break
				case 403:
					if (convertResponse.data?.error_code === 'UNAUTHORIZED') {
						setAlert('접근 권한이 없습니다.')
						navigate('/')
					}
					break
				case 404:
					if (convertResponse.data?.error_code === 'ROUTER_NOT_FOUND') {
						setAlert('해당 백엔드 요청은 존재하지 않습니다.')
					}

					break
				case 500:
					if (convertResponse.data?.error_code === 'INTERNAL_SERVER_ERROR') {
						setAlert(
							'서버에서 알 수 없는 오류가 발생하였습니다.\n관리자에게 문의해주세요.'
						)
					} else {
						navigate('/500')
					}

					break
			}

			// 데이터 후처리
			setData(convertResponse)

			if (process.env.REACT_APP_MODE === 'dev') {
				console.group(`${method} ${path}`)
				console.log(body)
				console.log(convertResponse?.statusCode, convertResponse?.data)
				console.groupEnd()
			}

			return convertResponse
		} catch (err) {
			setAlert('서버 통신 중 문제가 발생하였습니다.')
			console.group(err.message)
			console.log(err.stack)
			console.groupEnd()

			throw err
		} finally {
			closeSpinnerEvent()
			setIsLoading(false)
		}
	}

	return [data, request, isLoading]
}

export default useFetch
